import { useSelector } from 'react-redux'
import { SafetyCertificateFilled } from '@ant-design/icons'

import Box from '~/core/Box'
import { BoxPropsType } from '~/core/Box/type'
import Tooltip from '~/core/Tooltip'
import Text from '~/core/Text'
import { getUserIdentity } from '~/redux-modules/identity'
import isFlagEnabled from '~/lib/isFlagEnabled'
import colors from '~/styles/_colors.css'

/*
Customize the styling of this widget and it's Box container:
extraStyles for components that are styled via inline css, and
extraProps for the core components that are styled via props
*/
const iconBaseStyle = {
    color: colors.success,
    fontSize: '22px',
}
const textBaseStyle = {
    margin: '0 0 0 7px',
    color: colors.blackAlpha65,
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '22px',
    whiteSpace: 'pre-wrap',
}

enum styledElements {
    ICON = 'icon',
    TEXT = 'text',
}

type Props = {
    projectName: string
    extraStyles?: {
        [key in styledElements]?: {
            [key: string]: string | number
        }
    }
    extraProps?: {
        box?: BoxPropsType
    }
    iconTooltip?: {
        title?: string
    }
}

export default ({
    projectName,
    extraStyles,
    extraProps,
    iconTooltip,
}: Props) => {
    const isFeatureOn = useSelector(state => {
        const identity = getUserIdentity(state)
        const isEnabled = isFlagEnabled(
            identity,
            'FLAG_ENABLE_SECURE_PROJECTS',
            'true',
        )

        return isEnabled || null
    })
    const textStyles = {
        ...textBaseStyle,
        ...extraStyles?.text,
    }
    const iconStyles = {
        ...iconBaseStyle,
        ...extraStyles?.icon,
    }
    const boxProps = {
        ...extraProps?.box,
    }

    return (
        isFeatureOn && (
            <Box height="100%" alignItems="center" {...boxProps}>
                <Tooltip title={iconTooltip?.title}>
                    <SafetyCertificateFilled style={iconStyles} />
                </Tooltip>
                <Text style={textStyles}>{projectName}</Text>
            </Box>
        )
    )
}
